"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import classNames from "classnames";
import { Flash } from "../components/flash";
import ValueLinkTextDroppableInput from "./value_link_text_droppable_input";
import DisablingButton from "./disabling_button";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import paymentAddressIntegrationValidator from "./payment_address_integration_validator";
function errorElement(e) {
  return /* @__PURE__ */ jsxs("li", { children: [
    /* @__PURE__ */ jsx("i", { className: "warning fi-alert" }),
    " ",
    e.field.label,
    " ",
    e.errorMessage
  ] }, e.field.label + e.errorMessage);
}
function possibleRequiredFlag(field) {
  if (field.required) {
    return /* @__PURE__ */ jsx("i", { className: "fi-asterisk required" });
  }
}
function doesFieldHaveRequiredError(state, field) {
  return field.required && s.isBlank(state[field.value]);
}
const PaymentAddressEditor = React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    return _.extend({ blurredFields: [] }, this.props.address || {});
  },
  componentWillReceiveProps: function(props) {
    this.setState(props.address || {});
  },
  componentWillMount: function() {
    this.integrationValidator = paymentAddressIntegrationValidator(
      this.props.accountSettings
    );
  },
  render: function() {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        "data-component": "PaymentAddressEditor",
        className: "row",
        ref: "container",
        children: [
          this.possibleErrorMessages(),
          /* @__PURE__ */ jsxs("div", { className: "small-12 column required-legend", children: [
            /* @__PURE__ */ jsx("i", { className: "fi-asterisk required" }),
            " Required fields"
          ] }),
          /* @__PURE__ */ jsxs("form", { onSubmit: this.saveAddress, children: [
            _.map(this.fields, this.field),
            /* @__PURE__ */ jsx("div", { className: "small-12 column", children: /* @__PURE__ */ jsx(
              DisablingButton,
              {
                className: "expand button--confirmation",
                disabledText: this.isInvalid() ? "Enter all fields to save" : "Saving...",
                disabled: this.state.saving || this.isInvalid(),
                children: "Save Address"
              }
            ) })
          ] })
        ]
      }
    );
  },
  fields: [
    {
      label: "Name",
      value: "name",
      width: 12,
      required: true
    },
    {
      label: "Address Line 1",
      value: "address_line_1",
      width: 5,
      required: true
    },
    {
      label: "Address Line 2",
      value: "address_line_2",
      width: 5
    },
    {
      label: "City",
      value: "city",
      width: 5,
      required: true
    },
    {
      label: "State",
      value: "state",
      width: 2,
      required: true
    },
    {
      label: "Postal Code",
      value: "postal_code",
      width: 3,
      required: true
    },
    {
      label: "Country",
      value: "country",
      width: 10,
      required: false
    }
  ],
  field: function(field) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: "small-" + field.width + " column",
        children: [
          /* @__PURE__ */ jsxs("label", { children: [
            field.label,
            " ",
            possibleRequiredFlag(field),
            this.possibleValidationIconFor(field)
          ] }),
          /* @__PURE__ */ jsx(
            ValueLinkTextDroppableInput,
            {
              type: "text",
              "data-name": field.value,
              className: this.fieldClassNames(field),
              onBlur: this.markAsBlurredHandler(field),
              maxLength: "255",
              valueLink: this.linkState(field.value)
            }
          )
        ]
      },
      "field-" + field.value
    );
  },
  possibleErrorMessages: function() {
    const visibleFormErrors = this.visibleFormErrors().filter(
      (e) => !s.isBlank(e.errorMessage)
    );
    if (visibleFormErrors.length > 0) {
      return /* @__PURE__ */ jsx("ul", { className: "warning", children: visibleFormErrors.map(errorElement) });
    }
  },
  markAsBlurredHandler: function(field) {
    return () => {
      this.setState({
        blurredFields: _.union(this.state.blurredFields, [field.value])
      });
    };
  },
  visibleFormErrors: function() {
    return _.chain(this.fields).filter(this.shouldDisplayAsInvalid).map((f) => {
      return { field: f, errorMessage: this.errorMessageForField(f) };
    }).value();
  },
  possibleValidationIconFor: function(field) {
    if (this.shouldDisplayAsInvalid(field)) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "\xA0",
        /* @__PURE__ */ jsx("i", { className: "warning fi-alert" })
      ] });
    }
  },
  shouldDisplayAsInvalid: function(field) {
    const hasVisibleRequiredError = this.state.blurredFields.includes(field.value) && doesFieldHaveRequiredError(this.state, field);
    return hasVisibleRequiredError || this.doesFieldHaveIntegrationValidationError(field);
  },
  doesFieldHaveIntegrationValidationError: function(field) {
    return !this.integrationValidator.validate(
      field.value,
      this.state[field.value]
    ).valid;
  },
  fieldClassNames: function(field) {
    return classNames({
      validatingFormField: true,
      invalid: this.shouldDisplayAsInvalid(field)
    });
  },
  isInvalid: function() {
    return _.any(this.fields, _.negate(this.isFieldValid));
  },
  isFieldValid: function(field) {
    const noRequiredErrors = !doesFieldHaveRequiredError(this.state, field);
    const noIntegrationValidationError = !this.doesFieldHaveIntegrationValidationError(field);
    return noRequiredErrors && noIntegrationValidationError;
  },
  errorMessageForField: function(field) {
    return this.integrationValidator.validate(
      field.value,
      this.state[field.value]
    ).errorMessage;
  },
  saveAddress: function(e) {
    e.preventDefault();
    this.setState({ saving: true });
    this.props.saveAddress(this.state).then(
      (arg) => {
        Flash.success("Address successfully updated!");
        if (this.isMounted()) {
          this.setState({ saving: false });
        }
        return arg;
      },
      (arg) => {
        if (this.isMounted()) {
          this.setState({ saving: false });
        }
        return arg;
      }
    );
  }
});
export default PaymentAddressEditor;
